/**
 * We use this file for group all necesary constants
 */

/**
 * This array is for zip code affected for dana
 * We will use temporary to show PF81 and PF84 questions
 * when zipcode selected match with some of this array
 */

export const ARRAY_DANA_INECODE_AFFECTED = [
	'46005',
	'46007',
	'46008',
	'46012',
	'46015',
	'46019',
	'46021',
	'46022',
	'46026',
	'46029',
	'46031',
	'46035',
	'46017',
	'46054',
	'46060',
	'46065',
	'46070',
	'46076',
	'46077',
	'46079',
	'46080',
	'46085',
	'46093',
	'46094',
	'46095',
	'46098',
	'46102',
	'46105',
	'46108',
	'46109',
	'46110',
	'46111',
	'46115',
	'46123',
	'46125',
	'46129',
	'46133',
	'46136',
	'46139',
	'46147',
	'46148',
	'46152',
	'46155',
	'46156',
	'46158',
	'46159',
	'46165',
	'46169',
	'46172',
	'46176',
	'46186',
	'46190',
	'46191',
	'46193',
	'46194',
	'46197',
	'46212',
	'46213',
	'46214',
	'46215',
	'46223',
	'46229',
	'46230',
	'46232',
	'46233',
	'46234',
	'46235',
	'46238',
	'46244',
	'46248',
	'46249',
	'46256',
	'46261',
	'46904',
	'29007',
	'16126',
	'02042',
	'462500006', // Castellar-Oliveral
	'462500009', // El Palmar
	'462500010', // Perellonet
	'462500011', // Pinedo
	'462500013', // El Saler
	'462500015', // Horno de Alcedo
];

/**
 * Códigos de provincia de Cataluña (Barcelona, Girona, Lleida, Tarragona),
 * usados para la delegación de provincias catalanas en el IMV.
 */
export const CATALUNYA_PROVINCE_CODES = ['08', '17', '25', '43'];

/**
 * Denominaciones largas de las provincias de Cataluña, tal como aparecen
 * en el listado de provincias (provinces), para la comprobación de
 * exclusión dentro del formulario (PF46).
 */
export const CATALUNYA_PROVINCE_DENOMINATIONS = ['BARCELONA', 'GIRONA', 'LLEIDA', 'TARRAGONA'];

/**
 * Fecha a partir de la cual se activa por defecto la delegación de
 * provincias catalanas, si no hay override en la configuración remota
 * (catalunyaProvinceDelegation en prod.json).
 */
export const CATALUNYA_DELEGATION_DATE = new Date('2026-10-01T00:00:00');
//export const CATALUNYA_DELEGATION_DATE = new Date('2026-09-01T00:00:00');

/**
 * Determina si la delegación de provincias catalanas está activa.
 * Si hay un valor explícito en la configuración remota (prod.json),
 * ese valor manda por encima de la fecha, en cualquiera de los dos
 * sentidos (activar antes o desactivar después). Si no hay override,
 * se usa la fecha fija como comportamiento por defecto.
 *
 * @param configOverride - Valor de catalunyaProvinceDelegation en config, si existe
 * @returns True si la delegación de Cataluña debe considerarse activa
 */
export const isCatalunyaProvinceDelegationActive = (configOverride?: boolean): boolean => (configOverride !== undefined ? configOverride : new Date() >= CATALUNYA_DELEGATION_DATE);
